mutation RemoveUserScopes($id: ID!, $scopes: [InputUserScope]!) {
    removeUserScopes(id: $id, scopes: $scopes) {
        id
        role {
            _id
        }
        scope(getScopeEntity: true) {
            client
            campaign
            campaignOnlyClient
        }
    }
}
